import api from "./api";

class AlertManager {

    alerts(config?: any) {
        return api.get(`/alerts/`, config)
    }

    alert(id: number | string) {
        return api.get(`/alerts/${id}`)
    }

    alertUpdate(id: number | string, data: any) {
        return api.put(`alerts/${id}`, data)
    }

    toggleState(id: number | string) {
        return api.put(`alerts/${id}/toggle`)
    }

    delete(id: number | string) {
        return api.delete(`alerts/${id}`)
    }
}

const alertManager = new AlertManager()

export default alertManager
